/**
 * Allow disabling certain features/warnings for current browser session.
 *
 * We toggle a flag per feature within sessionStorage, which gets reset
 * once the browser is closed and reopened, but not on page reload.
 *
 */

const KEY_ASK_FOR_SEPA_DIRECT_DEBIT_MANDATE_DIALOG =
  'suppress-ask-for-sepa-direct-debit-mandate-dialog';

const KEY_BRAND_GROUPS_WITHOUT_CONTENT =
  'suppress-brand-groups-without-content';

const KEY_GEMA_FREE_CHANNEL_USED_DIALOG =
  'suppress-gema-free-channel-used-dialog';
const KEY_OFFLINE_DECODER_SELECTED = 'suppress-offline-decoder-selected';

const KEY_PROMOTE_CONTENT_CREATOR_DIALOG =
  'suppress-promote-content-creator-dialog';

export default {
  // Note: sessionStorage is not reactive, so these are all functions to call!
  methods: {
    _isSuppressedWarning(key) {
      return window.sessionStorage.getItem(key, false);
    },
    _suppressWarning(key) {
      window.sessionStorage.setItem(key, true);
    },
    // 'Selected Brand Groups without Content'
    isSuppressedSelectedBrandGroupsWithoutContentWarning() {
      return this._isSuppressedWarning(KEY_BRAND_GROUPS_WITHOUT_CONTENT);
    },
    suppressSelectedBrandGroupsWithoutContentWarning() {
      this._suppressWarning(KEY_BRAND_GROUPS_WITHOUT_CONTENT);
    },
    // 'Offline Decoder selected'
    isSuppressedOfflineDecoderSelectedWarning() {
      return this._isSuppressedWarning(KEY_OFFLINE_DECODER_SELECTED);
    },
    suppressOfflineDecoderSelectedWarning() {
      this._suppressWarning(KEY_OFFLINE_DECODER_SELECTED);
    },
    // 'Promote Content Creator'
    isSuppressedPromoteContentCreatorDialog() {
      return this._isSuppressedWarning(KEY_PROMOTE_CONTENT_CREATOR_DIALOG);
    },
    suppressPromoteContentCreatorDialog() {
      this._suppressWarning(KEY_PROMOTE_CONTENT_CREATOR_DIALOG);
    },
    // 'Ask for SEPA Mandate'
    isSuppressedAskForSepaDirectDebitMandateDialog() {
      return this._isSuppressedWarning(
        KEY_ASK_FOR_SEPA_DIRECT_DEBIT_MANDATE_DIALOG
      );
    },
    suppressAskForSepaDirectDebitMandateDialog() {
      this._suppressWarning(KEY_ASK_FOR_SEPA_DIRECT_DEBIT_MANDATE_DIALOG);
    },
    // 'GEMA free music channel used'
    isSuppressedGemaFreeChannelUsedDialog() {
      return this._isSuppressedWarning(KEY_GEMA_FREE_CHANNEL_USED_DIALOG);
    },
    suppressGemaFreeChannelUsedDialog() {
      this._suppressWarning(KEY_GEMA_FREE_CHANNEL_USED_DIALOG);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/suppressWarnings.js